import { render, staticRenderFns } from "./PriceAdjustmentRecord.vue?vue&type=template&id=0d921b7c&scoped=true"
import script from "./PriceAdjustmentRecord.vue?vue&type=script&lang=js"
export * from "./PriceAdjustmentRecord.vue?vue&type=script&lang=js"
import style0 from "./PriceAdjustmentRecord.vue?vue&type=style&index=0&id=0d921b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d921b7c",
  null
  
)

export default component.exports